import Transform from '@ember-data/serializer/transform';

export default class HVDatumTransform extends Transform {
  serialize() {
    console.log('HVDatumTransform', ...arguments);
  }
  deserialize(serialized) {
    return serialized && serialized._id;
  }
}
